import ExecutiveDashboard from "./ExecutiveDashboard";

export default ExecutiveDashboard;